import UILazy from './ui-lazy.js';
export default UILazy;
